import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import generateMiles from "./generateMiles";
import MapSection from "./MapSection";
import { Button, Card, Col, Form, Input, Modal, notification, Row, Select, Switch, Table, Tabs } from "antd";
import Running from "../../../System/Components/Running";
import generatePrices from "./generatePrices";
import { useGlobal } from "../../../System/Global/GlobalProvider";
import { calculateFuelSurchargeAmount } from "../../../System/Global/fuelSurchargeUtils";
import { getRecords } from "../../../System/Api/OPEXAPI";
import { unescapeNested } from "../../../System/Global/unescapeArray";

const QuickQuote = () => {

    const { UserData } = useGlobal();
    const [ form ] = Form.useForm();
    const [ form2 ] = Form.useForm();
    const [ client, setClient ] = useState()
    const [ directions, setDirections ] = useState()
    const [ calculating, setCalculating] = useState(false)
    const [ prices, setPrices ] = useState();
    const [ vehicleTypes, setVehicleTypes ] = useState([])
    const [ clients, setClients ] = useState([])
    const [isRoundTrip, setIsRoundTrip] = useState(false); 
    const [ noClient, setNoClient ] = useState(false);
    const navigate = useNavigate();
    const [ isModalVisible, setIsModalVisible ] = useState();
    const [ currentRecord, setCurrentRecord ] = useState();
    const [ miles, setMiles ] = useState(0)
    
    useEffect( () => {

        ( async () => {

            const _vehicles = await getRecords(`SELECT * FROM vehicle_types WHERE vtKey != ? ORDER BY maxWeight ASC`, ["296b00c6-feff-4b36-8e65-65044d74cc8c"])
            setVehicleTypes(_vehicles)

        })()
        

    },[])

    useEffect( () => {

        if (UserData?.clientKey) {
            ( async () => {

                const _client = unescapeNested( await getRecords(`SELECT * FROM clients WHERE clientKey = ?`, [UserData.clientKey]) )
                setClient(_client[0])
            })()
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[UserData?.clientKey])


    const start = async (_collections, _deliveries, _client) => {

        setCalculating(true)

        try {

            let _mileage = await generateMiles(_collections, _deliveries)

            let _prices = await generatePrices(
                _collections, 
                _deliveries, 
                _mileage.miles, 
                isRoundTrip ? 1 : 0,
                _mileage.start, 
                _mileage.end, 
                noClient ? "83d813a0-1b93-11ea-bf0d-4585c4f93cc7x" : _client.clientKey,
                _mileage.startPostcode,
                _mileage.endPostcode,
                noClient ? null : _client
            );



            // setMileage(_mileage)

            if (_mileage.directions) {

                setDirections(_mileage.directions)
                setMiles(_mileage.miles)
            }

            const priceTable = conditionPrices(_prices)

            setPrices(priceTable)

        } catch (err) {

            notification.error({
                message: "Error",
                description: "There was a problem with the collection or delivery information"
            })
            
        }

        setCalculating(false)



        
        

    }

    const conditionPrices = (_prices) => {

        let priceTable = [];
        console.log("conditionPrices - _prices.fuelSurcharge:", _prices?.fuelSurcharge);
        const fuelSurchargePercent = parseFloat(_prices?.fuelSurcharge?.effectivePercent || 0);
        console.log("conditionPrices - fuelSurchargePercent used:", fuelSurchargePercent);
    
        vehicleTypes.forEach((v) => {
            let systemSetRouteRate = _prices.systemSetRouteRates.find(p => p.vtKey === v.vtKey && p.price > 0);
            let clientSetRouteRate = _prices.clientSetRouteRates.find(p => p.vtKey === v.vtKey && p.price > 0);
            let mileageRate = _prices.mileagePrices.find(p => p.vtKey === v.vtKey && p.price > 0);


            // Precedence (not lowest-wins): a fixed route is an agreed rate and
            // must override the mileage calc even when mileage is cheaper.
            // Client fixed route > system fixed route > mileage.
            const chosen = clientSetRouteRate || systemSetRouteRate || mileageRate;
            const basePrice = chosen ? parseFloat(chosen.price) : 0;
            const fuelSurchargeAmount = calculateFuelSurchargeAmount(basePrice, fuelSurchargePercent);
            const totalPrice = parseFloat((basePrice + fuelSurchargeAmount).toFixed(2));
    
            priceTable.push({
                vtKey:  v.vtKey,
                price: totalPrice.toFixed(2),
                basePrice: basePrice.toFixed(2),
                fuelSurchargePercent: fuelSurchargePercent.toFixed(2),
                fuelSurchargeAmount: fuelSurchargeAmount.toFixed(2),
                totalPrice: totalPrice.toFixed(2),
                fuelSurchargeSource: _prices?.fuelSurcharge?.source || "none",
                name:   v.name,
                maxWeight: v.maxWeight,
                size: v.size,
                typeCode: v.typeCode,
            });
        });
    
        return priceTable;
    }

    const submitForm = (values) => {

        
            // let collections = values.rawCollections.split(",").map((c) => c.trim())
            // let deliveries = values.rawDeliveries.split(",").map((c) => c.trim())

            let collections = [values.rawCollections]
            let deliveries = [values.rawDeliveries]

            console.log("starting", collections, deliveries, client)
            start(collections, deliveries, client)
        
    }

    const QuoteForm = () => {

        return (
            <Card style={{marginBottom: 30}}>
                <Form onFinish={submitForm} form={form} layout="vertical">
                    <Row gutter={16}>
                        <Col xs={10}>
                            <Form.Item label="&nbsp;" style={{marginBottom: 5}}>
                                <Switch checked={isRoundTrip} style={{marginRight: 20}} checkedChildren="Round Trip" unCheckedChildren="One-way" onChange={(checked) => setIsRoundTrip(checked)} />
                            </Form.Item>
                        </Col>
                    </Row>
                    
                    <Form.Item name="rawCollections" label="Collection" style={{marginBottom: 5}} rules={[
                            {
                                required: true,
                                message: 'Please enter a collection point!',
                            }]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item name="rawDeliveries" label="Delivery" style={{marginBottom: 5}} rules={[
                            {
                                required: true,
                                message: 'Please enter a delivery point!',
                            }]}>
                        <Input/>
                    </Form.Item>
                    <Button style={{width: '100%'}} type="primary" htmlType="submit">Quote</Button>
                </Form>
            </Card>
        )

    }

    const onRowClick = (record) => {
        
        return {
            onClick: async (event) => {

                navigate(`/bookings/new/`)
            },
        };
    };

    

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const renderForm = () => {

        return (
            <Form for={form2} layout="vertical" initialValues={currentRecord} style={{marginTop: 30}}>
                <Row gutter={16}>
                    <Col span={24}>
                        { noClient &&
                        <Form.Item name="clientName" required>
                            <Input required placeholder="Client name" />
                        </Form.Item> }
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item name="email" required>
                                    <Input required placeholder="Email address" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="price" required>
                                    <Input required placeholder={"price"} type="number" />
                                </Form.Item>
                            </Col>
                            {currentRecord && (
                                <Col span={24}>
                                    <Card size="small" style={{marginBottom: 12}}>
                                        <Row gutter={16}>
                                            <Col span={8}>Base: £{currentRecord.basePrice || currentRecord.price}</Col>
                                            <Col span={8}>Fuel surcharge ({currentRecord.fuelSurchargePercent || "0.00"}%): £{currentRecord.fuelSurchargeAmount || "0.00"}</Col>
                                            <Col span={8} style={{textAlign: 'right', fontWeight: 'bold'}}>Total: £{currentRecord.totalPrice || currentRecord.price}</Col>
                                        </Row>
                                    </Card>
                                </Col>
                            )}
                            <Col span={24}>
                                <Form.Item name="freeType" required>
                                    <Input required placeholder={"Free type text"} type="text" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    
                    <Col span={24}>
                        <Form.Item>
                            <Button style={{width: '100%', height: 45}} htmlType='submit' type="primary">Send email</Button>
                        </Form.Item>
                    </Col>
                </Row>
                
                
            </Form>
        )
    }

    return (

        calculating ? 
        <Row gutter={16}>
            <Col span={24}>
                <div style={{textAlign: 'center', marginTop: 100}}>
                    <Running/>
                </div>
            </Col> 
        </Row>
        :

        <div style={{padding: 30}}>
        
                <Row gutter={16}>
        
                    <Col span={12}>
                        <QuoteForm/>
                        <MapSection height={450} directions={directions}/> 
                    </Col>
                    <Col xs={12}>
                        
                        <Table 
                            onRow={onRowClick}
                            rowKey={"vtKey"}
                            dataSource={prices}
                            pagination={false}
                            columns={[
                                {
                                    title: 'Vehicle.',
                                    dataIndex: 'name',
                                    key: 'name',
                                },
                                {
                                    title: 'Size.',
                                    dataIndex: 'size',
                                    key: 'size',
                                },
                                {
                                    title: 'Weight.',
                                    dataIndex: 'maxWeight',
                                    key: 'maxWeight',
                                },
                                {
                                    title: 'Base',
                                    render: item => <div style={{textAlign: 'right'}}>£{item.basePrice}</div>,
                                    key: 'basePrice',
                                },
                                {
                                    title: 'Fuel Surcharge',
                                    render: item => <div style={{textAlign: 'right'}}>£{item.fuelSurchargeAmount}</div>,
                                    key: 'fuelSurchargeAmount',
                                },
                                {
                                    title: 'Total',
                                    render: item => <div style={{textAlign: 'right', paddingRight: 10, fontWeight: 'bold', fontSize: 16}}>£{item.totalPrice || item.price}</div>,
                                    key: 'totalPrice',
                                },
                            ]}
                        />

                    <Modal
                        title="New email"
                        visible={isModalVisible}
                        onCancel={handleCancel}
                        footer={null}
                        width={900}
                    >
                        {renderForm()}
                    </Modal>
                        
                        
                    </Col>
                </Row>
            
                </div>
        
    )

}

export default QuickQuote;
